import React, { useState } from "react";
import cx from "clsx";
import { Table } from "../../../../shared/Table/Table";
import { Button } from "../../../../shared/Button/Button";
import { DeleteIcon } from "../../../../assets/Icons/DeleteIcon";
import styles from "../scss/GroupTable.module.scss";
import { Modal } from "../../../../shared/Modal/Modal";
import { useDeleteTimeTrackingGroup } from "../hooks/useDeleteTimeTrackingGroup";
import { useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "../../../../consts/api";
import { uiNotification } from "../../../../services/UINotificationService";
import { EditIcon } from "../../../../assets/Icons/EditIcon";
import { withRouter } from "react-router";
import { SETTINGS_ROUTES } from "../../../../consts/routes";
import { CircularProgress } from "../../../../shared/CircularProgress/CircularProgress";
import { typeOptions } from "./TimeCategoriesConfiguration.utils";

const GroupsTable = ({ groups, history, canEditTimeTrackingConfigs }) => {
  const [deleteGroupId, setDeleteGroupId] = useState(null);
  const queryClient = useQueryClient();

  const { mutate: deleteGroup, isLoading: isDeletingGroup } =
    useDeleteTimeTrackingGroup();

  const tableData = groups.map((group) => ({
    name: group.name,
    selectionType: typeOptions.find((option) => option.value === group.type)
      .label,
    actions: (
      <div className={styles.actions}>
        <Button
          className={cx(styles.iconButtons)}
          variant="text"
          onClick={() => goToEditConfig(group.id)}
          isDisabled={!canEditTimeTrackingConfigs?.permitted}
        >
          <EditIcon width="15px" />
          Edit
        </Button>
        <Button
          className={cx(styles.iconButtons)}
          variant="text"
          onClick={() => setDeleteGroupId(group.id)}
          isDisabled={!canEditTimeTrackingConfigs?.permitted}
        >
          <DeleteIcon width="15px" />
          Delete
        </Button>
      </div>
    ),
  }));

  const goToEditConfig = (id) => {
    history.push(SETTINGS_ROUTES.timeClock.createConfiguration(id));
  };

  return (
    <>
      <Table
        bgColor="white"
        data={tableData}
        cols={[
          {
            data: "Name",
            accessor: "name",
          },
          {
            data: "Selection Type",
            accessor: "selectionType",
          },
          {
            data: "Actions",
            accessor: "actions",
          },
        ]}
      />
      {deleteGroupId && (
        <Modal
          isOpen
          onClose={() => setDeleteGroupId(null)}
          header={<h2>Delete Group</h2>}
          headerNoBorder
          footerNoBorder
          footerClassName={styles.deleteModalFooter}
          footer={
            <>
              <Button
                size="small"
                variant="outlined"
                onClick={() => setDeleteGroupId(null)}
              >
                Cancel
              </Button>
              <Button
                size="small"
                onClick={() => {
                  deleteGroup(
                    { id: deleteGroupId },
                    {
                      onSuccess: () => {
                        setDeleteGroupId(null);
                        queryClient.invalidateQueries([
                          QUERY_KEYS.timeclockSettings.getTimeTrackingConfigs,
                        ]);
                      },
                      onError: (error) => {
                        uiNotification.error(
                          error.response?.data?.message ||
                            "Failed to delete group",
                        );
                      },
                    },
                  );
                }}
                leftAdornment={
                  isDeletingGroup ? (
                    <CircularProgress size="tiny" color="white" />
                  ) : null
                }
                isDisabled={isDeletingGroup}
              >
                Delete
              </Button>
            </>
          }
        >
          <p>Are you sure you want to delete this group?</p>
        </Modal>
      )}
    </>
  );
};

export default withRouter(GroupsTable);
